import { render } from "./MenuLateralDashLora.vue?vue&type=template&id=02157155&scoped=true"
import script from "./MenuLateralDashLora.vue?vue&type=script&lang=js"
export * from "./MenuLateralDashLora.vue?vue&type=script&lang=js"

import "./MenuLateralDashLora.vue?vue&type=style&index=0&id=02157155&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02157155"]])

export default __exports__